import { Link } from "@tanstack/react-router";
import { useTranslate } from "@tolgee/react";

import { LocaleLinks } from "#/components/locale/locale-links";
import { LocalizedLink } from "#/components/locale/localized-link";
import { cn } from "#/lib/utils";

import { sectionClass } from "./landing-styles";

export function LandingFooter() {
	const { t } = useTranslate();
	const year = new Date().getFullYear();

	return (
		<footer
			className={cn(sectionClass, "px-[18px] py-[36px] md:px-[42px] md:pt-0")}
		>
			<div className="flex items-end gap-[20px]">
				<strong className="text-title1 text-foreground">
					tenbagger
				</strong>
			</div>

			<div className="mt-6 flex flex-col gap-6 text-muted-foreground md:flex-row md:items-center md:justify-between">
				<p>
					&copy; {year} Tenbagger. {t("footer.all-rights")}
				</p>
				<div className="flex items-center gap-[18px] text-foreground/88">
					<LocalizedLink
						to="/learn"
						className="transition hover:text-foreground"
					>
						{t("footer.notices")}
					</LocalizedLink>
					<Link to="/terms" className="transition hover:text-foreground">
						{t("footer.terms")}
					</Link>
					<LocaleLinks />
				</div>
			</div>
		</footer>
	);
}
